import tags from "../../../components/tags";
import text from "./text";
import { img } from "../../../components/html";
import gRepresentation from "./authorization-code-grant.jpg";

export default {
  "Authorization Code Grant: step 1": {
    get: {
      tags: [tags.accessTokens],
      summary: text.summary,
      description: `
      GET /oauth
${text.description.summary}
## Graphical representation of token acquisition and communication with API 
${img(gRepresentation)}

## First step: obtaining an access token
Client redirects the user to the authorization server with the following parameters

Server will check parameters. The user will be prompted to sign in and confirm access. If everything goes without error, user will be redirect to the address specified in \`redirect_uri\` with the parameters in step 3
`,
      parameters: [
        {
          name: "response_type",
          in: "query",
          required: true,
          description: "Response type - constant",
          schema: {
            type: "string",
            example: "code"
          }
        },
        {
          name: "client_id",
          in: "query",
          required: true,
          description: "Client identification key - Identity Key",
          schema: {
            type: "string",
            example: "CHANGE THIS"
          }
        },
        {
          name: "redirect_uri",
          in: "query",
          required: true,
          description:
            "Address to which the authorization code is sent after successful authorization. You must enable the redirect URI in the section `Nastavení integrace`.",
          schema: {
            type: "string",
            example: "CHANGE THIS"
          }
        },
        {
          name: "state",
          in: "query",
          required: true,
          description:
            "CSRF token - This parameter is not required but recommended.The client should store it in a session and compare it to the token that receives in response.",
          schema: {
            type: "string"
          }
        }
      ],
      responses: {
        "200": {
          description: "Query response parameters",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  code: {
                    type: "string",
                    description:
                      "Authorization code for access token - required in second step.",
                    example: "576de25...nVDnephY3iXF"
                  },
                  state: {
                    type: "string",
                    description:
                      "CSRF token - The client should compare it to the token stored in the session.",
                    example: "generated-state"
                  }
                }
              }
            }
          }
        }
      },
      security: []
    }
  }
};
